module.exports = __webpack_public_path__ + "img/bg_foot.21f71005.jpg";